import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {Slider, Pagination} from 'react-slick';
import { LazyLoadImage, trackWindowScroll} from 'react-lazy-load-image-component';
import { formatNumber } from '../../../utils';
import Loader from '../../Loader';
import './styles.scss';

const propTypes = {
  snapshots: PropTypes.array,
};

const defaultProps = {
  snapshots: [],
  slickSettings: {
    infinite: true,
    arrows: false,
    adaptiveHeight: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide:0,
    paginationName: 'favorite-snapshots-pagination',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  }
};

class FavoriteSnapshotsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = { navigationEnabled: false, showAll: false };
    this.paginationRender = this.paginationRender.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.snapshots.length > 3) {
      this.setState({navigationEnabled: true});
    } else {
      this.setState({navigationEnabled: false});
    }
  }

  componentDidMount() {
    if(this.props.snapshots.length > 3) {
      this.setState({navigationEnabled: true});
    } else {
      this.setState({navigationEnabled: false});
    }
  }

  next(){
    if(this.state.navigationEnabled)
      this.favoriteSlider.slickNext();
    document.dispatchEvent(new CustomEvent('resize'));
  }
  previous(){
    if(this.state.navigationEnabled)
      this.favoriteSlider.slickPrev();
    document.dispatchEvent(new CustomEvent('resize'));
  }

  paginationRender(currentPage, totalPages) {
    return (
      <span ref="slideNumber" type="text" className="pagination-numbers">{currentPage} / {totalPages} </span>
    );
  }

  render() {
    const { snapshots, slickSettings, scrollPosition } = this.props;
    const { navigationEnabled, showAll } = this.state;
    const disabled = (navigationEnabled) ? '' : ' disabled';
    const loaderProps = { style: { height: 144 }, dark: true };
    return (
      <div className="member-slider-group">
        <div className="row">
          <div className="section-header col-12 bg-fff-80 border-grey">
            <div className="row no-gutters">
              <div className="title-link border-r-grey title-block">Favorite Snapshots</div>
              <div className="title-block col">{ formatNumber(snapshots.length) } Images</div>
              {this.state.showAll ? (
                <div className="col m-0 row align-items-center">
                  <div className="col m-0 row text-right">
                    <div className="col m-0 py-0 title-block"><button className="btn btn-sm" onClick={() => { this.setState({ showAll: !this.state.showAll }) }}>Show Pages</button></div>
                  </div>
                </div>
              ) : (
                <div className="col m-0 row align-items-center">
                  <div className="col m-0 row text-right">
                    <div className="col m-0 py-0 title-block"><button className="btn btn-sm" onClick={() => { this.setState({ showAll: !this.state.showAll }) }}>View All</button></div>
                    <div className="align-self-center col-auto px-0"><Pagination name="favorite-snapshots-pagination" /></div>
                  </div>
                  <div className={"title-block border-l-grey pagination-button" + disabled} onClick={this.previous}><i className="icon-ButtonArrowLeft"></i></div>
                  <div className={"title-block border-l-grey pagination-button" + disabled} onClick={this.next}><i className="icon-ButtonArrowRight"></i></div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          { snapshots.length > 0 && (
            showAll ? (
            <div>
              <div className="row no-gutters">
                {snapshots.map(function(snapshot, index){
                    let currentViewers = (snapshot.current_viewers === 0 || !snapshot.current_viewers) ? ' no-viewers ' : '';
                    let snapshotText = (snapshot.live) ? 'watch snapshot': 'watch highlight';

                    return (
                      <div className="col-3 p-1" key={snapshot.id}>
                        <div className={"favorite-snapshot-item" }>
                          <Link to={snapshot.snapshots_url} target="_blank" className="snapshot-result">
                            <div className="snapshot-inner-wrap">
                              <div className="snapshot-hover-info"><div className="u-font-foundation-light abs-center hover-text">View <br />Snapshot</div></div>
                              <LazyLoadImage
                                alt={'test'}
                                height={144}
                                src={snapshot.thumbnail_url.replace('http://', 'https://')} // use normal <img> attributes as props
                                placeholder={<Loader ref="loader" {...loaderProps} fill />}
                                scrollPosition={scrollPosition}
                              />
                            </div>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
            </div>
            ) : (
              <Slider {...slickSettings} ref={c => this.favoriteSlider = c} className='favorite-snapshots-slider'  paginationRender={this.paginationRender}>
                {snapshots.map(function(snapshot, index){
                  let currentViewers = (snapshot.current_viewers === 0 || !snapshot.current_viewers) ? ' no-viewers ' : '';
                  let snapshotText = (snapshot.live) ? 'watch snapshot': 'watch highlight';

                  return (
                    <div className="favorite-snapshot-item-wrap" key={snapshot.id}>
                      <div className={"favorite-snapshot-item" }>
                        <Link to={snapshot.snapshots_url} target="_blank" className="snapshot-result">
                          <div className="snapshot-inner-wrap">
                            <div className="snapshot-hover-info"><div className="u-font-foundation-light abs-center hover-text">View <br />Snapshot</div></div>
                            <LazyLoadImage
                                alt={'test'}
                                height={144}
                                src={snapshot.thumbnail_url.replace('http://', 'https://')} // use normal <img> attributes as props
                                placeholder={<Loader ref="loader" {...loaderProps} fill />}
                                scrollPosition={scrollPosition}
                              />
                          </div>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </Slider>
              )
          )}
        </div>
      </div>
    )
  }
}

FavoriteSnapshotsView.propTypes = propTypes;
FavoriteSnapshotsView.defaultProps = defaultProps;

export default trackWindowScroll(FavoriteSnapshotsView);
